import React, { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Dropdown from '../../Dropdown/Dropdown';
import { LISTING_BRANDS } from '../../../constants/listing.constants';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { parse, stringify } from '../../../util/urlHelpers';
import { InlineTextButton } from '../../Button/Button';

import css from './BrandDropdown.module.css';

export const SEARCH_PARAM_NAME = 'manufacturer';

const BrandDropdown = () => {
  const intl = useIntl();
  const location = useLocation();
  const { pathname, search, state } = location;
  const history = useHistory();

  const handleValueChanged = useCallback(
    value => {
      const parsedSearch = parse(search);
      const { page, ...rest } = parsedSearch;

      const searchString = `?${stringify({ ...rest, [SEARCH_PARAM_NAME]: value })}`;

      history.replace(`${pathname}${searchString}`, state);
    },
    [history, search, SEARCH_PARAM_NAME, pathname]
  );

  const handleBrandReset = useCallback(() => {
    const parsedSearch = parse(search);
    const { page, [SEARCH_PARAM_NAME]: prevBrand, ...rest } = parsedSearch;

    const searchString = `?${stringify(rest)}`;

    history.replace(`${pathname}${searchString}`, state);
  }, [history, search, pathname]);

  const brand = parse(search)[SEARCH_PARAM_NAME];

  const mergedItems = useMemo(() => {
    if (!brand) return LISTING_BRANDS;

    if (LISTING_BRANDS.find(l => l.value === brand.toUpperCase())) return LISTING_BRANDS;

    return [{ value: brand.toUpperCase(), label: brand }, ...LISTING_BRANDS];
  }, [brand]);

  return (
    <div>
      <Dropdown
        className={css.root}
        dropdownInputClassName={css.dropdownInput}
        options={mergedItems}
        filterType="includes"
        currentOptionMessageId="BrandDropdown.searchBy"
        value={brand?.toUpperCase()}
        onChange={handleValueChanged}
        placeholder={intl.formatMessage({ id: 'BrandDropdown.placeholder' })}
        enableCurrentOptionSelect
      />
      {brand && (
        <InlineTextButton onClick={handleBrandReset}>
          <FormattedMessage id="Global.resetFilter" />
        </InlineTextButton>
      )}
    </div>
  );
};

export default BrandDropdown;
